export const PRIVATE_SYSTEM_EVENT = 'app.tellus.system'
export const PRIVATE_ROOMS_ACCOUNT_DATA = 'app.tellus.privateRooms'
export const PRIVATE_HIDDEN_ROOMS_ACCOUNT_DATA = 'app.tellus.hiddenRooms'

export const PRIVATE_MATRIX_PROFILE_COLLECTION = 'app.tellus.matrixProfile'
export const PRIVATE_MATRIX_PROFILE_RKEY = 'self'

export const PRIVATE_PRIVACY_SETTINGS_COLLECTION = 'app.tellus.privacySettings'
export const PRIVATE_PRIVACY_SETTINGS_RKEY = 'self'

export const PRIVATE_ENDPOINTS_COLLECTION = 'app.tellus.privateEndpoints'
export const PRIVATE_ENDPOINTS_RKEY = 'self'

export const PRIVATE_POST_EVENT = 'app.tellus.privatePost'
export const PRIVATE_STORY_EVENT = 'app.tellus.privateStory'
export const PRIVATE_FOLLOW_REQUEST_EVENT = 'app.tellus.followRequest'
export const PRIVATE_FOLLOW_ACTION_EVENT = 'app.tellus.followRequestAction'
export const PRIVATE_REACTION_EVENT = 'app.tellus.privateReaction'
export const PRIVATE_COMMENT_EVENT = 'app.tellus.privateComment'

export type PrivateSystemKind =
  | 'privateAudience'
  | 'privateFeed'
  | 'privateRequests'

export type PrivateRoomKindConfig = {
  kind: PrivateSystemKind
  joinRule: 'invite' | 'public'
  historyVisibility?: 'joined' | 'invited'
}

export type PrivateRoomsAccountData = {
  audienceRoomId: string
  feedRoomId: string
  requestsRoomId: string
  ownerDid: string
  updatedAt: string
}

export type PrivateHiddenRoomsAccountData = {
  roomIds: Record<string, {kind: PrivateSystemKind; ownerDid?: string}>
}

export type PrivateMatrixProfileRecord = {
  $type: typeof PRIVATE_MATRIX_PROFILE_COLLECTION
  mxid: string
  createdAt: string
  updatedAt?: string
}

export type PrivatePrivacySettingsRecord = {
  $type: typeof PRIVATE_PRIVACY_SETTINGS_COLLECTION
  isPrivate: boolean
  updatedAt: string
}

export type PrivateEndpointsRecord = {
  $type: typeof PRIVATE_ENDPOINTS_COLLECTION
  requestsRoomId: string
  audienceRoomId?: string
  feedRoomId?: string
  updatedAt: string
}

export type PrivateMedia = {
  mxc: string
  mimeType: string
  width?: number
  height?: number
  durationMs?: number
}

export type PrivatePostEvent = {
  id: string
  authorDid: string
  createdAt: string
  text?: string
  media?: PrivateMedia[]
  visibility: 'private'
  replyToId?: string
}

export type PrivateStoryEvent = {
  id: string
  authorDid: string
  createdAt: string
  expiresAt: string
  media: PrivateMedia[]
  textOverlays?: Array<{
    text: string
    x: number
    y: number
    color?: string
    size?: number
  }>
}

export type PrivateFollowRequestEvent = {
  id: string
  fromDid: string
  fromMxid: string
  createdAt: string
  message?: string
}

export type PrivateFollowRequestActionEvent = {
  requestId: string
  action: 'accept' | 'decline' | 'cancel'
  byDid: string
  createdAt: string
}

export type PrivateReactionEvent = {
  targetId: string
  byDid: string
  reaction: 'like'
  createdAt: string
}

export type PrivateCommentEvent = {
  targetId: string
  byDid: string
  text: string
  createdAt: string
}

export type PrivateRequestState = 'none' | 'requested' | 'approved' | 'declined'

export type PrivateProfileState = {
  isPrivate: boolean
  approved: boolean
  requestState: PrivateRequestState
  requestId?: string
  updatedAt: number
}

export type PrivateStoryState = {
  count: number
  updatedAt: number
}

export type PrivateFollowRequest = {
  id: string
  fromDid: string
  fromMxid: string
  createdAt: string
  message?: string
}
